import {
  FormControl,
  FormErrorMessage,
  Radio,
  RadioGroup,
  Stack
} from '@chakra-ui/react'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { FormLabel, InputGroup } from '@/components'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useSelections } from '@/hooks'
import type { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'

export const AdditionalPropertyInfoCpp = () => {
  const { insuranceParams } = useInsuranceParams()

  const { data: dataStavRekonstrukce } = useSelections(SelectionType.StavRekonstrukce)

  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { register, watch, formState: { errors }, getFieldState, setValue, getValues } = useFormContext<WizardPropertyAdditionalData>()

  const mainBuildingRequired = getValues('property.additionalDataCpp.mainBuildingRequired')
  const secondaryBuildingRequired = getValues('property.additionalDataCpp.secondaryBuildingRequired')
  const secondaryBuildingsAreaRequired = getValues('property.additionalDataCpp.secondaryBuildingsAreaRequired')
  const realtyInNewPriceRequired = getValues('property.additionalDataCpp.realtyInNewPriceRequired')
  const reconstractionStateRequired = getValues('property.additionalDataCpp.reconstractionStateRequired')

  const stavRekonstrukceId = watch('property.additionalDataCpp.reconstractionStateId')

  return (
    <>
      {mainBuildingRequired &&
        <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.mainBuilding}>
          <FormLabel>Hlavní stavba</FormLabel>
          <InputGroup
            isDisabled={isContracted}
            id="mainBuilding"
            htmlSize={30}
            autoComplete="off"
            errors={errors.property?.additionalDataCpp?.mainBuilding}
            {...register('property.additionalDataCpp.mainBuilding')}
          />
        </FormControl>
      }

      {(secondaryBuildingRequired || secondaryBuildingsAreaRequired) &&
        <>
          {secondaryBuildingRequired &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.secondaryBuilding}>
              <FormLabel>Vedlejší stavba</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="secondaryBuilding"
                //htmlSize={8}
                autoComplete="off"
                errors={errors.property?.additionalDataCpp?.secondaryBuilding}
                {...register('property.additionalDataCpp.secondaryBuilding')}
              />
            </FormControl>
          }
          {secondaryBuildingsAreaRequired &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.secondaryBuildingsArea}>
              <FormLabel>Plocha vedlejších staveb</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="secondaryBuildingsArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataCpp?.secondaryBuildingsArea}
                {...register('property.additionalDataCpp.secondaryBuildingsArea')}
              />
            </FormControl>
          }
        </>

      }
      {realtyInNewPriceRequired &&
        <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.realtyInNewPrice}>
          <FormLabel>Pojištění bytové jednotky na cenu</FormLabel>

          <RadioGroup
            isDisabled={isContracted}
            value={watch('property.additionalDataCpp.realtyInNewPrice') == true ? 'true' : 'false'}
            onChange={(val) => setValue('property.additionalDataCpp.realtyInNewPrice', val === 'true')}
          >
            <Stack>
              <Radio value="false">Obvyklou</Radio>
              <Radio value="true">Novou</Radio>
            </Stack>
          </RadioGroup>

          {errors.property?.additionalDataCpp?.realtyInNewPrice && <FormErrorMessage>{errors.property?.additionalDataCpp?.realtyInNewPrice?.message}</FormErrorMessage>}
        </FormControl>
      }

      {reconstractionStateRequired &&
        <>
          <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.reconstractionStateId}>
            <FormLabel tooltip='Vyberte, zda v objektu proběhla či probíhá rekonstrukce'>Rekonstrukce</FormLabel>

            <RadioGroup
              isDisabled={isContracted}
              onChange={x => setValue('property.additionalDataCpp.reconstractionStateId', parseInt(x))}
              value={stavRekonstrukceId?.toString()}
            >
              <Stack>
                {dataStavRekonstrukce?.data.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)).map((item) => (
                  <Radio value={item.id.toString()} key={item.id.toString()}>
                    {item.description}
                  </Radio>
                ))}
              </Stack>
            </RadioGroup>
            {errors.property?.additionalDataCpp?.reconstractionStateId && <FormErrorMessage>{errors.property?.additionalDataCpp?.reconstractionStateId.message}</FormErrorMessage>}
          </FormControl>

          {stavRekonstrukceId && stavRekonstrukceId == Selection.RekonstrukceCelkova &&
            <FormControl isInvalid={!!errors.property?.additionalDataCpp?.reconstractionYear}>
              <FormLabel>Rok poslední rekonstrukce</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="reconstructionYear"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataCpp?.reconstractionYear}
                {...register('property.additionalDataCpp.reconstractionYear')}
              />
            </FormControl>
          }
        </>
      }
    </>
  )
}
